import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Auth";
import CentroHome from "./pages/CentroHome";
import CentroSchedule from "./pages/CentroSchedule";
import Matricula from "./pages/Matricula";
import PerfilHome from "./pages/PerfilHome";
import PerfilCentro from "./pages/PerfilCentro";
import PerfilLogopedia from "./pages/PerfilLogopedia";
import Admin from "./pages/Admin";
import TeamLogin from "./pages/TeamLogin";
import ResetPassword from "./pages/ResetPassword";
import LogoAlta from "./pages/LogoAlta";
import { SedeSelect, SedeHome } from "./pages/LogopediaHome";
import { Privacidad, AvisoLegal, PoliticaCentro, Calendario } from "./pages/Legal";

const Loading = () => (
  <div className="flex min-h-screen items-center justify-center bg-beige text-lg">Cargando...</div>
);

function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/entrar" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/perfil" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/entrar" element={<Login />} />
          <Route path="/equipo" element={<TeamLogin />} />
          <Route path="/recuperar-contrasena" element={<ResetPassword />} />
          <Route path="/centro" element={<CentroHome />} />
          <Route path="/centro/horario" element={<CentroSchedule />} />
          <Route path="/centro/matricula" element={<Matricula />} />
          <Route path="/centro/politica" element={<PoliticaCentro />} />
          <Route path="/logopedia" element={<SedeSelect />} />
          <Route path="/logopedia/:sede" element={<SedeHome />} />
          <Route path="/logopedia/:sede/alta" element={<LogoAlta />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/calendario" element={<Calendario />} />
          <Route path="/perfil" element={<Protected><PerfilHome /></Protected>} />
          <Route path="/perfil/centro" element={<Protected><PerfilCentro /></Protected>} />
          <Route path="/perfil/logopedia" element={<Protected><PerfilLogopedia /></Protected>} />
          <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
